module.exports = "../static/images/83d276.png";